import { render } from "./documents_editor_modal.vue?vue&type=template&id=79d1df18"
import script from "./documents_editor_modal.vue?vue&type=script&lang=js"
export * from "./documents_editor_modal.vue?vue&type=script&lang=js"

import exportComponent from "/home/premiergalop/dev/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__